import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module LocationsSaga
 */

/**
 *
 * @param {object} data
 */
export function setLocationsData(data) {
  store.dispatch({
    type: actionTypes.SET_LOCATIONS_DATA,
    payload: {
      data: data
    }
  });
}

export function setLocationsResults(data, count) {
  store.dispatch({
    type: actionTypes.SET_LOCATIONS_RESULTS,
    payload: {
      data: data,
      count: count
    }
  });
}

/**
 *
 * @param {object} data
 */
export function setZoneAndWardData(data) {
  store.dispatch({
    type: actionTypes.SET_ZONE_AND_WARD,
    payload: {
      data: data
    }
  });
}

/**
 *
 * @param {object} data
 */
export function createNewLocation(data) {
  store.dispatch({
    type: actionTypes.CREATE_LOCATION,
    payload: {
      data: data
    }
  });
}

/**
 *
 * @param {object} data
 */
export function getComplaintSummary(data) {
  store.dispatch({
    type: actionTypes.GET_COMPLAINT_SUMMARY_DATA,
    payload: {
      data: data
    }
  });
}

export function setLocationSummaryData(
  manPowerAverage,
  lastManPowerCapturedAverage
) {
  store.dispatch({
    type: actionTypes.PUT_LOCATION_SUMMARY_DATA,
    payload: {
      manPowerAverage: manPowerAverage,
      lastManPowerCapturedAverage: lastManPowerCapturedAverage
    }
  });
}

export function getLocationSummary() {
  store.dispatch({
    type: actionTypes.GET_LOCATION_SUMMARY
  });
}

export function uploadLocationImage(data, locationId) {
  store.dispatch({
    type: actionTypes.UPLOAD_LOCATION_IMAGE,
    payload: {
      data: data,
      locationId: locationId
    }
  });
}

export function fetchLocationsAssets(locationId) {
  store.dispatch({
    type: actionTypes.FETCH_LOCATIONS_ASSETS
  });
}

export function fetchSelectedLocationData(dateRange) {
  store.dispatch({
    type: actionTypes.FETCH_SELECTED_LOCATION_DATA,
    payload: { dateRange }
  });
}

export function setSelectedLocationData(data) {
  store.dispatch({
    type: actionTypes.SET_SELECTED_LOCATION_DATA,
    payload: data
  });
}

export function updateLocationStatus(data) {
   store.dispatch({
    type: actionTypes.UPDATE_LOCATION_STATUS,
    payload: data
  });
}